export default __webpack_public_path__ + "static/dr20-f84f3ee1dc59fc78b2b917bfbaad6c54.png";